import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$stateSlug/$gameSlug")({
  component: () => <Outlet />,
});
